import { action } from "mobx";
import AwsS3SignedUrlRepository from "~/repository/AwsS3/AwsS3SignedUrlRepository";

class AwsS3SignedUrlStore {
  /**
   * @property {AwsS3SignedUrlRepository|null}
   */
  awsS3SignedUrlRepository = null;

  constructor() {
    this.awsS3SignedUrlRepository = new AwsS3SignedUrlRepository();
  }

  @action
  getOne(data) {
    return this.awsS3SignedUrlRepository.fetchOne(data);
  }
}

export default AwsS3SignedUrlStore;
